<template>
  <div class="public-content order">
    <div class="breadcrumb">关联平台</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="平台号:">
              <el-input v-model="formInline.code" placeholder="请输入平台号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台名称:">
              <el-input v-model="formInline.name" placeholder="请输入平台名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务:">
              <el-input v-model="formInline.salename" placeholder="请输入业务" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台类型:">
              <el-select v-model="formInline.storeTypeid" placeholder="请选择" clearable>
                <el-option v-for="item in storeTypeList" :label="item.name" :key="item.id" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机号:">
              <el-input v-model="formInline.phone" placeholder="请输入手机号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="创建日期:" class="el-date-width">
              <el-date-picker clearable v-model="value2" type="daterange" align="left" unlink-panels range-separator="至" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8" class="fn-right form-btn">
            <div v-show="ifAddPlateform" style="line-height:30px;float: right;margin-right: 20px;">当前业务：{{ fullName }}</div>
            <el-button class="search-ok" @click="onSubmit" round>查询</el-button>
            <el-button class="search-ok" @click="cancelRelate" v-show="$hasPermission('crm:admin:salesman:editRelation') && !ifAddPlateform" round>取消分配</el-button>
            <el-button class="search-ok" @click="addPlateform" v-show="$hasPermission('crm:admin:salesman:editRelation') && !ifAddPlateform" round type="primary"> 添加平台</el-button>
            <el-button class="search-ok" @click="cancelRelate" v-show="$hasPermission('crm:admin:salesman:editRelation') && ifAddPlateform" round type="primary">关联 </el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border @selection-change="handleSelectionChange" style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="code" label="平台号" min-width="10px">
          </el-table-column>
          <el-table-column prop="name" label="平台名称" min-width="10px">
          </el-table-column>
          <el-table-column prop="storeType" label="平台类型" min-width="10">
          </el-table-column>
          <el-table-column prop="salesman.fullName" label="业务" min-width="10">
          </el-table-column>
          <el-table-column prop="phone" label="手机号" min-width="10">
          </el-table-column>
          <el-table-column prop="address.completeAddress" label="地址" min-width="10">
          </el-table-column>
          <el-table-column prop="createdTime" label="创建日期" min-width="10">
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" :queryInfo="queryInfo" v-if="queryInfo.total !== ''" @changePage="changePage"></v-pagination>
    </div>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { getPlatListBySaleman, storeTypeGetStoreTypeList, editRelation, getSalemanById, storeGetStoreList } from '@/api/crm'
export default {
  name: 'order',
  components: {
    VPagination
  },
  inject: ['reload'],
  data () {
    return {
      ifAddPlateform: false,
      queryInfo: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      formInline: {
        code: '',
        name: '',
        salename: '',
        phone: '',
        storeTypeid: '',
        createTimeBegin: '',
        createTimeEnd: ''
      },
      tableData: [],
      value2: '',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      gridData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海'
      }],
      selected: [],
      fullName: '',
      storeTypeList: []
    }
  },
  created () {
    this.onSubmit()
    this.getSaleman()
    this.getStoreTypeList()
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  watch: {
    value2 (params) {
      if (params) {
        this.formInline.createTimeBegin = this.$moment(params[0]).format('YYYY-MM-DD')
        this.formInline.createTimeEnd = this.$moment(params[1]).format('YYYY-MM-DD')
      } else {
        this.formInline.createTimeBegin = ''
        this.formInline.createTimeEnd = ''
      }
    }
  },
  methods: {
    getStoreTypeList () {
      storeTypeGetStoreTypeList().then(res => {
        if (res.data.success) {
          this.storeTypeList = res.data.data
        }
      })
    },
    getSaleman () {
      getSalemanById(this.$route.params.id).then(res => {
        this.fullName = res.data.data.fullName
      })
    },
    onSubmit () {
      // 向后台发送post请求,获取查询数据存储在tableData
      if (!this.ifAddPlateform) {
        getPlatListBySaleman({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, searchStoreVo: { salesmanId: this.$route.params.id, ...this.formInline } }).then((res) => {
          if (res.data.success) {
            this.tableData = res.data.data.records.map(a => {
              if (a.phone) {
                a.phone = this.$msg.filterBridal(a.phone)
              }
              return a
            })
            this.queryInfo.total = res.data.data.total
          }
        })
      } else {
        storeGetStoreList({ ...this.queryInfo, storeVo: this.formInline }).then(res => {
          if (res.data.success) {
            this.tableData = res.data.data.records.map(a => {
              if (a.phone) {
                a.phone = this.$msg.filterBridal(a.phone)
              }
              return a
            })
            this.queryInfo.total = res.data.data.total
          }
        })
      }
    },
    getPlatformStatus (status) {
      if (status === '审核') {
        this.$router.push('./checkplatform')
      }
      if (status === '查看/编辑') {
        this.$router.push('./editplatform')
      }
    },
    cancelRelate () {
      if (this.selected.length === 0) {
        this.$message.error('未选择平台')
        return
      }
      editRelation({ id: +this.$route.params.id, storeIds: this.selected, status: this.ifAddPlateform ? '1' : '0' }).then(res => {
        this.$message.success(this.ifAddPlateform ? '关联成功' : '已取消关联')
        this.$router.go(-1)
        this.onSubmit()
      })
    },
    addPlateform () {
      this.ifAddPlateform = true
      this.queryInfo.pageNum = 1
      this.onSubmit()
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    },
    handleSelectionChange (val) {
      this.selected = []
      val.forEach(item => {
        this.selected.push(item.id)
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";

.el-date-width {
  /deep/ .el-form-item__content {
    //  width: 50% !important;
    //  display: flex;
  }
}
</style>
